/*
 * Copyright (c) 2019. Sonrai Analytics Ltd.
 * Developed by Deva Sen., Ryan Duffy & Warren Dowey
 */

export class PermissionModel {
  private _permissionId?: string;
  private _permissionName?: string;
  private _permissionDescription?: string;
  private _permissionAction?: string;
  private _isProjectPermission?: boolean;
  private _permissionCategory?: string;

  constructor(
    permissionId?: string,
    permissionName?: string,
    permissionDescription?: string,
    permissionAction?: string,
    isProjectPermission?: boolean,
    permissionCategory?: string
  ) {
    this._permissionId = permissionId;
    this._permissionName = permissionName;
    this._permissionDescription = permissionDescription;
    this._permissionAction = permissionAction;
    this._isProjectPermission = isProjectPermission;
    this._permissionCategory = permissionCategory;
  }

  get permissionId(): string {
    return this._permissionId;
  }

  set permissionId(value: string) {
    this._permissionId = value;
  }

  get permissionName(): string {
    return this._permissionName;
  }

  set permissionName(value: string) {
    this._permissionName = value;
  }

  get permissionDescription(): string {
    return this._permissionDescription;
  }

  set permissionDescription(value: string) {
    this._permissionDescription = value;
  }

  get permissionAction(): string {
    return this._permissionAction;
  }

  set permissionAction(value: string) {
    this._permissionAction = value;
  }

  get isProjectPermission(): boolean {
    return this._isProjectPermission;
  }

  set isProjectPermission(value: boolean) {
    this._isProjectPermission = value;
  }

  public get permissionCategory(): string {
    return this._permissionCategory;
  }

  public set permissionCategory(permissionType: string) {
    this._permissionCategory = permissionType;
  }

  toJson(): Object {
    const object = {
      permission_id: this.permissionId,
      permission_name: this.permissionName,
      permission_description: this.permissionDescription,
      permission_action: this.permissionAction,
      is_project_permission: this.isProjectPermission,
      permission_category: this.permissionCategory,
    };
    Object.keys(object).forEach((k) => !object[k] && object[k] !== undefined && delete object[k]);
    return object;
  }

  fromJson(input: any): PermissionModel {
    return new PermissionModel(
      input['permission_id'],
      input['permission_name'],
      input['permission_description'],
      input['permission_action'],
      input['is_project_permission'],
      input['permission_category']
    );
  }
}
